export const siteInfo = {
  name: 'kaiyun.com',
  fullName: 'kaiyun.com 官方平台',
  description: 'kaiyun.com 官方访问入口说明、注册登录流程、常见问题解答及安全使用建议，帮助用户快速找到官方入口并顺利完成操作。',
  keywords: 'https www kaiyun com, https www kaiyun com 官网入口, https www kaiyun com 登录, https www kaiyun com 注册, kaiyun com 官方网站, kaiyun 平台使用教程, kaiyun 账号安全',
  url: 'https://aiubo.cn',
  foundingYear: '2018',
  logo: 'kaiyun.com',
};

export const navLinks = [
  { label: '首页', href: '/' },
  { label: '平台教程', href: '/category/tutorial' },
  { label: '账号安全', href: '/category/security' },
  { label: '最新资讯', href: '/category/news' },
  { label: '赛事指南', href: '/category/sports' },
  { label: '关于我们', href: '/about' },
];

export const heroContent = {
  title: 'kaiyun.com 官方入口指南',
  subtitle: '提供完整的官方访问入口说明、注册登录流程及安全使用建议，助您快速、安全地访问 kaiyun.com 官方平台',
  ctaPrimary: '访问官方网站',
  ctaSecondary: '查看使用教程',
};

export const features = [
  {
    id: 'feat-1',
    icon: 'ri-shield-check-line',
    title: '官方认证入口',
    description: '提供经官方认证的访问入口，确保您访问的是 kaiyun.com 真实官方网站，避免进入仿冒或钓鱼网站，全面保障您的账号与资金安全。',
  },
  {
    id: 'feat-2',
    icon: 'ri-guide-line',
    title: '完整使用教程',
    description: '涵盖注册、登录、密码找回、实名认证、资金管理等全流程操作指南，图文并茂，即使是新手用户也能快速上手掌握平台各项功能。',
  },
  {
    id: 'feat-3',
    icon: 'ri-lock-password-line',
    title: '账号安全保障',
    description: '详细介绍账号安全设置方法，包括强密码策略、二次验证、设备管理、登录异常提醒等多重防护机制，全方位守护您的账号安全。',
  },
  {
    id: 'feat-4',
    icon: 'ri-customer-service-2-line',
    title: '7×24 小时支持',
    description: '提供全天候客户服务支持，涵盖在线客服、常见问题解答、邮箱支持等多种渠道，确保您在遇到任何问题时都能获得及时有效的帮助。',
  },
];

export const categories = [
  {
    slug: 'tutorial',
    name: '平台使用教程',
    icon: 'ri-book-open-line',
    description: '从注册到使用的完整操作指南，手把手教您玩转 kaiyun.com',
    imageQuery: 'Modern%20minimalist%20educational%20tutorial%20guide%20illustration%20with%20clean%20warm%20lighting%2C%20flat%20design%20style%2C%20soft%20cream%20background%2C%20learning%20concept%20with%20subtle%20geometric%20shapes%2C%20editorial%20quality%2C%20professional%20aesthetic',
  },
  {
    slug: 'security',
    name: '账号安全指南',
    icon: 'ri-shield-keyhole-line',
    description: '账号保护、密码管理、安全设置全方位指导',
    imageQuery: 'Modern%20minimalist%20security%20protection%20illustration%20with%20clean%20warm%20lighting%2C%20flat%20design%20style%2C%20soft%20cream%20background%2C%20shield%20concept%20with%20subtle%20geometric%20shapes%2C%20editorial%20quality%2C%20professional%20aesthetic',
  },
  {
    slug: 'news',
    name: '最新资讯动态',
    icon: 'ri-newspaper-line',
    description: '平台最新公告、功能更新、行业资讯一网打尽',
    imageQuery: 'Modern%20minimalist%20news%20announcement%20illustration%20with%20clean%20warm%20lighting%2C%20flat%20design%20style%2C%20soft%20cream%20background%2C%20megaphone%20concept%20with%20subtle%20geometric%20shapes%2C%20editorial%20quality%2C%20professional%20aesthetic',
  },
  {
    slug: 'sports',
    name: '赛事资讯指南',
    icon: 'ri-trophy-line',
    description: '热门赛事资讯、观赛指南与平台使用技巧',
    imageQuery: 'Modern%20minimalist%20sports%20event%20illustration%20with%20clean%20warm%20lighting%2C%20flat%20design%20style%2C%20soft%20cream%20background%2C%20trophy%20concept%20with%20subtle%20geometric%20shapes%2C%20editorial%20quality%2C%20professional%20aesthetic',
  },
];

export const articles = [
  {
    id: 'article-1',
    slug: 'kaiyun-register-guide',
    title: 'kaiyun.com 新用户注册完整流程指南（2026最新版）',
    excerpt: '详细介绍 kaiyun.com 新用户注册的每一个步骤，从访问官网到完成注册，包含常见问题及注意事项，帮助您快速创建账号。',
    category: 'tutorial',
    categoryName: '平台使用教程',
    imageQuery: 'Modern%20minimalist%20registration%20form%20illustration%20with%20clean%20warm%20lighting%2C%20flat%20design%20style%2C%20soft%20cream%20background%2C%20signup%20concept%20with%20subtle%20geometric%20shapes%2C%20editorial%20quality%2C%20professional%20aesthetic',
    date: '2026-08-05',
    readTime: '8分钟',
    tags: ['注册', '新手指南', '账号创建'],
    content: `
## 一、访问 kaiyun.com 官方网站

首先，您需要通过正规渠道访问 kaiyun.com 官方平台。请注意以下几点：

1. **确认网址正确**：请在浏览器地址栏输入 https www kaiyun com 进行访问，务必确认网址拼写完全正确。
2. **避免搜索进入**：尽量避免通过搜索引擎点击广告链接进入，以防误入仿冒网站。
3. **收藏官方网址**：建议将正确的官方网址添加到浏览器收藏夹，方便日后快速访问。

## 二、开始注册流程

进入 kaiyun.com 官网首页后，您可以在页面右上角找到"注册"按钮，点击即可开始注册流程。

### 步骤一：填写基本信息

- **用户名**：设置一个 6-16 位的用户名，支持字母和数字组合
- **登录密码**：设置 8-20 位密码，建议包含大小写字母、数字和特殊符号
- **确认密码**：再次输入密码以确认无误
- **手机号码**：输入您的真实手机号码，用于接收验证码

### 步骤二：手机验证

输入手机号码后，点击"获取验证码"，系统将向您的手机发送一条包含 6 位数字验证码的短信。请在 5 分钟内输入验证码完成验证。

### 步骤三：设置安全信息

为提高账号安全性，建议您在注册时设置以下安全信息：
- **密保问题**：选择并设置三个密保问题及对应答案
- **绑定邮箱**：绑定常用电子邮箱作为备用验证方式

## 三、完成注册

确认所有信息无误后，勾选"我已阅读并同意《用户服务协议》"，点击"立即注册"按钮即可完成注册。

注册成功后，系统将自动跳转至登录页面，您可以使用刚注册的账号登录 kaiyun.com 平台。

## 四、常见注册问题

**Q: 收不到验证码怎么办？**
A: 请检查手机是否欠费、信号是否正常，或尝试等待 60 秒后重新获取。如仍无法收到，请联系在线客服。

**Q: 用户名已被占用怎么办？**
A: 建议在用户名后添加数字或使用其他组合，系统会实时提示用户名是否可用。

**Q: 注册后需要实名认证吗？**
A: 是的，为保障账号安全，建议您在注册后尽快完成实名认证。
    `,
  },
  {
    id: 'article-2',
    slug: 'kaiyun-login-guide',
    title: 'kaiyun.com 官方登录入口详解与常见登录问题解决方案',
    excerpt: '全面解析 https www kaiyun com 官方登录入口的使用方法，包括密码登录、短信登录等多种方式，以及忘记密码、账号锁定等问题的处理方案。',
    category: 'tutorial',
    categoryName: '平台使用教程',
    imageQuery: 'Modern%20minimalist%20login%20screen%20illustration%20with%20clean%20warm%20lighting%2C%20flat%20design%20style%2C%20soft%20cream%20background%2C%20authentication%20concept%20with%20subtle%20geometric%20shapes%2C%20editorial%20quality%2C%20professional%20aesthetic',
    date: '2026-08-03',
    readTime: '6分钟',
    tags: ['登录', '账号', '密码找回'],
    content: `
## 一、官方登录入口

访问 https www kaiyun com 官方登录入口有以下方式：

1. **直接访问官网**：在浏览器输入网址后，点击页面右上角的"登录"按钮
2. **收藏登录页**：将登录页面添加为书签，方便下次快速访问

## 二、登录方式详解

### 密码登录

最常见也是最基础的登录方式：

1. 输入您的注册用户名或绑定的手机号码
2. 输入登录密码
3. 如需安全验证，输入图形验证码
4. 点击"登录"按钮完成登录

### 短信验证码登录

如果您忘记密码或觉得密码登录不够便捷：

1. 输入已绑定的手机号码
2. 点击"获取验证码"
3. 输入收到的短信验证码
4. 点击"登录"按钮完成登录

## 三、常见登录问题

**忘记密码怎么办？**
点击登录页面的"忘记密码"链接，按提示通过手机验证码或密保问题重置密码。

**账号被锁定怎么办？**
连续输错密码 5 次后，账号将被临时锁定 30 分钟。30 分钟后自动解锁，或联系客服协助处理。

**登录时提示"异地登录"？**
这是安全保护机制，建议修改密码并开启登录保护功能。
    `,
  },
  {
    id: 'article-3',
    slug: 'kaiyun-security-guide',
    title: 'kaiyun.com 账号安全防护全攻略：密码管理、二次验证与设备保护',
    excerpt: '学习如何为您的 kaiyun.com 账号设置最高级别安全防护，包括强密码策略、两步验证、设备绑定、登录提醒等全方位保护措施。',
    category: 'security',
    categoryName: '账号安全指南',
    imageQuery: 'Modern%20minimalist%20cybersecurity%20illustration%20with%20clean%20warm%20lighting%2C%20flat%20design%20style%2C%20soft%20cream%20background%2C%20lock%20shield%20concept%20with%20subtle%20geometric%20shapes%2C%20editorial%20quality%2C%20professional%20aesthetic',
    date: '2026-07-28',
    readTime: '10分钟',
    tags: ['安全', '密码', '二次验证'],
    content: `
## 一、为什么账号安全如此重要

在数字时代，账号安全直接关系到您的个人信息和资金安全。kaiyun.com 作为专业的在线平台，虽然已有多重安全机制，但用户自身的安全意识同样不可或缺。

## 二、强密码策略

### 什么样的密码才算"强"？

- **长度**：至少 12 位以上
- **复杂度**：包含大写字母、小写字母、数字和特殊符号
- **唯一性**：不在其他平台使用相同密码
- **无规律**：避免使用生日、手机号、姓名拼音等个人信息

### 密码管理建议

- 使用密码管理器生成和存储复杂密码
- 每 3-6 个月定期更换密码
- 发现异常登录后立即修改密码

## 三、开启二次验证

二次验证（2FA）是保护账号最有效的措施之一：

1. 登录后在"安全中心"找到"二次验证"设置
2. 推荐使用 Google Authenticator 等认证应用
3. 备份恢复码并妥善保管

## 四、设备管理与登录提醒

- 定期检查"登录设备"列表，移除不认识的设备
- 开启"异地登录提醒"功能
- 不在公共电脑上勾选"记住密码"
    `,
  },
  {
    id: 'article-4',
    slug: 'kaiyun-announcement-2026',
    title: 'kaiyun.com 2026年平台重要更新公告与功能优化说明',
    excerpt: '了解 kaiyun.com 平台在 2026 年的重要功能更新，包括界面优化、安全升级、新增功能等，让您第一时间掌握平台最新动态。',
    category: 'news',
    categoryName: '最新资讯动态',
    imageQuery: 'Modern%20minimalist%20announcement%20megaphone%20illustration%20with%20clean%20warm%20lighting%2C%20flat%20design%20style%2C%20soft%20cream%20background%2C%20update%20concept%20with%20subtle%20geometric%20shapes%2C%20editorial%20quality%2C%20professional%20aesthetic',
    date: '2026-08-01',
    readTime: '5分钟',
    tags: ['公告', '更新', '新功能'],
    content: `
## 平台重要更新公告

kaiyun.com 始终致力于为用户提供更优质的服务体验。2026 年第三季度，我们进行了一系列重要的平台更新：

### 一、界面全面优化

全新升级的用户界面更加简洁直观，导航结构经过重新设计，用户可以更快速地找到所需功能。移动端适配也进行了大幅改进。

### 二、安全系统升级

引入了更先进的加密技术和风控系统，进一步提升用户数据和资金的安全性。新增智能风险识别功能，实时保护用户账号。

### 三、新增实用功能

- 一键切换语言版本
- 智能客服系统升级，响应速度提升 40%
- 新增消息中心，重要通知不再错过
    `,
  },
  {
    id: 'article-5',
    slug: 'kaiyun-premier-league-guide',
    title: '2026英超赛季观赛指南：kaiyun.com 平台赛事资讯使用技巧',
    excerpt: '英超新赛季即将开赛，本文为您介绍如何通过 kaiyun.com 平台获取最新赛事资讯，掌握球队动态、赛程安排及数据统计等信息。',
    category: 'sports',
    categoryName: '赛事资讯指南',
    imageQuery: 'Modern%20minimalist%20football%20soccer%20stadium%20illustration%20with%20clean%20warm%20lighting%2C%20flat%20design%20style%2C%20soft%20cream%20background%2C%20sports%20concept%20with%20subtle%20geometric%20shapes%2C%20editorial%20quality%2C%20professional%20aesthetic',
    date: '2026-07-25',
    readTime: '7分钟',
    tags: ['英超', '赛事', '观赛指南'],
    content: `
## 2026 英超赛季概览

2026/2027 赛季英超联赛即将拉开帷幕，20 支顶级球队将再次为冠军荣耀展开激烈角逐。

### 赛季看点

- 卫冕冠军能否延续辉煌
- 升班马球队的新赛季表现
- 夏窗重磅引援的首秀
- 经典德比战的赛程安排

### 平台赛事功能使用技巧

在 kaiyun.com 平台，您可以：

1. 查看完整赛程表和实时积分榜
2. 获取球队和球员详细数据统计
3. 阅读专业赛前分析和赛后复盘
4. 关注喜爱的球队并接收个性化推送

### 安全观赛提醒

请通过 https www kaiyun com 官方入口访问平台，拒绝使用任何非官方渠道，确保您的观赛体验安全可靠。
    `,
  },
  {
    id: 'article-6',
    slug: 'kaiyun-password-reset',
    title: 'kaiyun.com 密码找回与账号恢复完整操作手册',
    excerpt: '忘记 kaiyun.com 登录密码？不用担心！本文详细介绍通过手机验证码、密保问题、客服协助三种方式找回密码的完整步骤。',
    category: 'security',
    categoryName: '账号安全指南',
    imageQuery: 'Modern%20minimalist%20password%20reset%20illustration%20with%20clean%20warm%20lighting%2C%20flat%20design%20style%2C%20soft%20cream%20background%2C%20key%20concept%20with%20subtle%20geometric%20shapes%2C%20editorial%20quality%2C%20professional%20aesthetic',
    date: '2026-07-20',
    readTime: '5分钟',
    tags: ['密码找回', '账号恢复', '安全'],
    content: `
## 密码找回流程

如果您忘记了 kaiyun.com 的登录密码，请按照以下步骤操作：

### 方式一：手机验证码找回

1. 在登录页面点击"忘记密码"
2. 输入注册时绑定的手机号码
3. 获取并输入短信验证码
4. 设置新的登录密码
5. 使用新密码重新登录

### 方式二：密保问题找回

1. 选择"通过密保问题找回"
2. 正确回答您之前设置的密保问题
3. 验证通过后设置新密码

### 方式三：联系客服找回

如以上方式均无法使用，可联系 kaiyun.com 官方客服获取人工协助。请准备好您的身份证明材料以便验证。
    `,
  },
];

export const faqs = [
  {
    id: 'faq-1',
    question: 'https www kaiyun com 是官方网站吗？如何确认访问的是真实官网？',
    answer: '是的，https www kaiyun com 是官方访问入口。为确保访问的是真实官网，请注意：1）在浏览器地址栏直接输入网址；2）确认地址栏显示 HTTPS 安全锁标志；3）核对网站底部备案信息；4）避免通过不明来源的链接跳转。建议将官方网址添加到收藏夹，每次从收藏夹中打开。',
  },
  {
    id: 'faq-2',
    question: 'kaiyun.com 注册需要哪些信息？注册流程复杂吗？',
    answer: '注册 kaiyun.com 账号需要提供：用户名、登录密码、手机号码。注册流程非常简单，仅需 3-5 分钟即可完成：访问官网 → 点击注册 → 填写基本信息 → 手机验证 → 完成注册。建议注册后尽快完善安全信息，如绑定邮箱和设置密保问题。',
  },
  {
    id: 'faq-3',
    question: '忘记 kaiyun.com 登录密码怎么办？',
    answer: '可以通过以下方式找回密码：1）在登录页面点击"忘记密码"，通过绑定手机号接收验证码重置密码；2）通过密保问题验证重置；3）联系官方客服获取人工协助。建议开启二次验证功能以提高账号安全性。',
  },
  {
    id: 'faq-4',
    question: 'kaiyun.com 平台是否支持手机访问？有APP吗？',
    answer: 'kaiyun.com 平台全面支持移动端访问，您可以通过手机浏览器访问 https www kaiyun com 获得优化的移动端体验。关于APP的详细信息，请以官方平台公告为准。',
  },
  {
    id: 'faq-5',
    question: '如何保障 kaiyun.com 账号的安全？',
    answer: '保障账号安全建议：1）设置强密码（12位以上，含大小写字母、数字、特殊符号）；2）开启二次验证；3）定期更换密码；4）不在公共设备保存登录信息；5）开启登录异常提醒；6）定期检查登录设备列表。平台也提供了多重安全防护机制全方位保护您的账号。',
  },
  {
    id: 'faq-6',
    question: 'kaiyun.com 平台的客服联系方式有哪些？',
    answer: 'kaiyun.com 提供多渠道客户服务：1）在线客服（7×24小时）；2）官方客服邮箱；3）常见问题自助查询。您可以根据问题类型选择最便捷的联系方式。一般性问题建议先查阅帮助中心，紧急问题可直接联系在线客服。',
  },
];

export const aboutContent = {
  brandIntro: {
    title: '关于 kaiyun.com',
    paragraphs: [
      'kaiyun.com 是一个专注于为用户提供优质在线服务的综合性平台。自成立以来，我们始终坚持"用户至上、安全第一"的运营理念，致力于为广大用户提供安全、便捷、高效的服务体验。',
      '平台拥有专业的技术团队和客户服务团队，持续优化产品功能和用户体验。我们深知在数字时代，账号安全和信息保护的重要性，因此在技术架构和安全防护方面投入了大量资源，建立了多层次的安全防护体系。',
      'kaiyun.com 严格遵循相关法律法规和行业标准，持有合法的运营资质。我们倡导负责任的平台使用理念，为用户提供必要的使用指导和风险提示，帮助用户建立正确的使用习惯。',
    ],
  },
  reputation: {
    title: '平台信誉与资质',
    items: [
      { label: '运营年限', value: '自 2018 年起稳定运营超过 8 年' },
      { label: '服务用户', value: '累计服务超过百万用户' },
      { label: '安全认证', value: '通过国际标准信息安全认证' },
      { label: '加密技术', value: '采用 SSL/TLS 256 位加密传输' },
      { label: '资金安全', value: '多重资金安全保障机制' },
      { label: '隐私保护', value: '严格的数据隐私保护政策' },
    ],
  },
  contact: {
    title: '联系我们',
    description: '如有任何疑问或需要帮助，欢迎通过以下方式联系我们：',
    email: 'support@kaiyun.com',
    hours: '7×24 小时全天候服务',
    address: '在线服务平台',
  },
};